import { useAtomValue, useSetAtom } from 'jotai';

import { PREORDERS_TABLE_TAB } from '@ekhodealer/ekho-common';
import { Divider, Stack } from '@ekhodealer/ekho-common/rev';

import type { ReactNode } from 'react';

import { FiltersDrawer } from '@common/components/FiltersDrawer';

import { useSearchPreorders } from '../api/useSearchPreorders';
import { allAppliedFiltersAtom } from '../atoms/preordersAppliedFiltersAtoms';
import { clearAllFiltersAtom, preordersParamsAtom,preorderTabFilterAtom } from '../atoms/preordersAtoms';

import { FiltersDrawerEstRetailPriceSection } from './filters/FiltersDrawerEstRetailPriceSection';
import { FiltersDrawerOrderDateSection } from './filters/FiltersDrawerOrderDateSection';
import { FiltersDrawerPreorderAmountSection } from './filters/FiltersDrawerPreorderAmountSection';
import { FiltersDrawerStateSection } from './filters/FiltersDrawerStateSection';
import { FiltersDrawerStatusSection } from './filters/FiltersDrawerStatusSection';
import { FiltersDrawerVehicleModelSection } from './filters/FiltersDrawerVehicleModelSection';
import { PreordersFiltersDrawerAppliedFiltersSection } from './filters/PreordersFiltersDrawerAppliedFiltersSection';

interface PreordersFiltersDrawerProps {
	/** The trigger element that opens the drawer */
	trigger: ReactNode;
}

export const PreordersFiltersDrawer = ({ trigger }: PreordersFiltersDrawerProps) => {
	const allAppliedFilters = useAtomValue(allAppliedFiltersAtom);
	const clearAllFilters = useSetAtom(clearAllFiltersAtom);
	const hasAppliedFilters = allAppliedFilters.length > 0;
	const currentTab = useAtomValue(preorderTabFilterAtom);
	const showStatusFilter = !currentTab || currentTab === PREORDERS_TABLE_TAB.ALL;

	const params = useAtomValue(preordersParamsAtom);
	const { data, isLoading } = useSearchPreorders(params);
	const queryCount = data?.count ?? 0;

	return (
		<FiltersDrawer
			trigger={trigger}
			appliedFiltersSection={<PreordersFiltersDrawerAppliedFiltersSection />}
			filterSections={
				<Stack>
					<Divider />
					<FiltersDrawerOrderDateSection />
					<Divider />
					{showStatusFilter && (
						<>
							<FiltersDrawerStatusSection />
							<Divider />
						</>
					)}
					<FiltersDrawerVehicleModelSection />
					<Divider />
					<FiltersDrawerStateSection />
					<Divider />
					<FiltersDrawerPreorderAmountSection />
					<Divider />
					<FiltersDrawerEstRetailPriceSection />
				</Stack>
			}
			hasAppliedFilters={hasAppliedFilters}
			clearAllFilters={clearAllFilters}
			queryCount={queryCount}
			isLoading={isLoading}
		/>
	);
};
